import * as Yup from "yup";
export const courseBasicInfoSchema = Yup.object().shape({
  courseTitle: Yup.string().required("Course title is required"),
  courseLevel: Yup.string().required("Course level is required"),
  courseDepartment: Yup.string().required("Course Department is required"),
  courseDomain: Yup.string().required("Course Process is required"),
  courseDescription: Yup.string().required("Course Description is required"),
  // learningOutcome: Yup.string().required("Learning OutComes is required"),
});
